// extracted by mini-css-extract-plugin
module.exports = {"darkModeButton":"DarkModeSwitch_darkModeButton__3fCkv"};